import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27528689"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 mt-5" }
const _hoisted_4 = { class: "w-max-content col-lg-2" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "col-lg-5" }
const _hoisted_7 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_8 = { class: "w-max-content col-lg-2" }
const _hoisted_9 = { class: "col-lg-10" }
const _hoisted_10 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_11 = { class: "w-max-content col-lg-2" }
const _hoisted_12 = { class: "col-lg-5" }
const _hoisted_13 = { class: "col-lg-5" }
const _hoisted_14 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_15 = { class: "w-max-content col-lg-2" }
const _hoisted_16 = { class: "col-lg-10" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_18 = { class: "w-max-content col-lg-2" }
const _hoisted_19 = { class: "col-lg-10" }
const _hoisted_20 = { class: "d-flex justify-content-center" }

import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ConvertFromLocalTime } from '@/constants/datepicker'
import { YELLOOP_CHECK_REJOIN_INTENTION_VALUES, YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES } from '@/constants/index'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object as PropType<{
      rejoin_intention: number
      previous_rejoin_intention: number
      rejoin_intention_updated_at: string
      desired_information: number
      previous_desired_information: number
      desired_information_updated_at: string
      confirmation_updated_at: string
    }>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()



const rejoinIntentionName = computed(() => {
  return YELLOOP_CHECK_REJOIN_INTENTION_VALUES[props.data.rejoin_intention] ?? ''
})

const previousRejoinIntentionName = computed(() => {
  return YELLOOP_CHECK_REJOIN_INTENTION_VALUES[props.data.previous_rejoin_intention] ?? ''
})

const desiredInformationName = computed(() => {
  return YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES[props.data.desired_information] ?? ''
})

const previousDesiredInformationName = computed(() => {
  return YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES[props.data.previous_desired_information] ?? ''
})

const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus?management_no=desc`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('OE30YelloopCheck')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('OE30RejoinIntention')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(rejoinIntentionName)), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('OE30PreviousInformation')) + _toDisplayString(_unref(previousRejoinIntentionName)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('OE30RejoinIntentionUpdatedAt')), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data?.rejoin_intention_updated_at ? _unref(ConvertFromLocalTime)(__props.data.rejoin_intention_updated_at) : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('OE30DesiredInformation')), 1),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(desiredInformationName)), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)('OE30PreviousInformation')) + _toDisplayString(_unref(previousDesiredInformationName)), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)('OE30DesiredInformationUpdatedAt')), 1)
      ]),
      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.data?.desired_information_updated_at ? _unref(ConvertFromLocalTime)(__props.data.desired_information_updated_at) : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('OE30ConfirmationUpdatedAt')), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(__props.data?.confirmation_updated_at ? _unref(ConvertFromLocalTime)(__props.data.confirmation_updated_at) : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToList
      }, null, 8, ["title"])
    ])
  ]))
}
}

})